import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  MenuItem,
  ListItemText,
  Typography,
  CircularProgress
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import {
  loadLayoutOptions,
  assignLayoutToEvent
} from 'state/modules/planimetry'
import { FilterComponent } from '~/views/shared'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { useStyles } from './AssignPlanimetryDialog.style'

export const AssignPlanimetryDialog = ({
  open,
  onClose,
  onSave,
  locationId,
  eventId
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { layoutOptions, pendingLayoutOptions, pendingAssign } = useSelector(
    (state) => state.planimetry
  )
  const [searchValue, setSearchValue] = useState('')
  const [filteredLocations, setFilteredLocations] = useState(layoutOptions)
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    if (open) {
      async function fetchData() {
        await dispatch(loadLayoutOptions(locationId))
      }
      fetchData().then()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, locationId])

  useEffect(() => {
    if (layoutOptions) {
      setFilteredLocations(
        layoutOptions.filter((l) =>
          l.Name.toLowerCase().includes(searchValue.toLowerCase())
        )
      )
    }
  }, [searchValue, layoutOptions])

  const handleAssignLayout = async () => {
    if (!selected) return
    try {
      const layout = await dispatch(assignLayoutToEvent(selected.Id, eventId))
      showSnackbarSuccess('Planimetría asignada con éxito')
      onSave(layout?.Id)
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSearchValue('')
      setSelected(null)
    }
  }

  const handleClose = () => {
    setSearchValue('')
    setSelected(null)
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        Asignar Planimetría
        <IconButton
          aria-label='close'
          onClick={handleClose}
          className={classes.closeButton}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <FilterComponent
          performSearch={(val) => setSearchValue(val)}
          searchValue={searchValue}
          placeholder='Buscar planimetria...'
        />
        <div style={{ overflow: 'auto' }}>
          {pendingLayoutOptions ? (
            <div className={classes.containerProgress}>
              <CircularProgress
                size={24}
                className={classes.circularProgress}
              />
              <Typography>Cargando...</Typography>
            </div>
          ) : filteredLocations?.length > 0 ? (
            filteredLocations.map((loc) => (
              <MenuItem
                key={loc.Id}
                dense
                selected={selected?.Id === loc.Id}
                onClick={() => setSelected(loc)}
                className={
                  selected?.Id === loc.Id
                    ? classes.itemContainerSelected
                    : classes.itemContainer
                }>
                <ListItemText
                  primary={loc.Name}
                  secondary={`Sectores: ${loc.SectorsCount}`}
                  className={classes.textSpacing}
                />
              </MenuItem>
            ))
          ) : (
            <Typography
              variant='body2'
              color='textSecondary'
              className={classes.emptyList}>
              No se encontraron planimetrias
            </Typography>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Cancelar
        </Button>
        <Button
          onClick={handleAssignLayout}
          color='primary'
          variant='contained'
          disabled={!selected}
          className={classes.saveButton}>
          {pendingAssign ? (
            <CircularProgress size={24} color='secondary' />
          ) : (
            'Asignar Planimetria'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AssignPlanimetryDialog
